import React, { useState, useEffect, useCallback } from "react";
import { Table, Pagination, Row, Col, Tag } from "antd";
import axios from "axios";
import { formatDateTime } from "../../helpers/date";

const columns = [
  {
    title: "Date",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 180,
    render: (text) => (text ? formatDateTime(text) : "-"),
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    width: 100,
    render: (text) => (
      <Tag color={text === "EARN" ? "green" : "red"}>{text}</Tag>
    ),
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    width: 100,
  },
  {
    title: "Remarks",
    dataIndex: "remarks",
    key: "remarks",
  },
];

const UserPointHistory = ({ userId }) => {
  const [pointHistory, setPointHistory] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    limit: 20,
    totalSize: 0,
  });
  const [loading, setLoading] = useState(false);

  const fetchPointHistory = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`/api/user/${userId}/point-history`, {
        params: {
          page: pagination.currentPage,
          limit: pagination.limit,
        },
      });
      setPointHistory(res.data.data);
      setPagination((prev) => ({
        ...prev,
        totalSize: res.data.pagination?.totalSize,
      }));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [userId, pagination.currentPage, pagination.limit]);

  useEffect(() => {
    fetchPointHistory();
  }, [fetchPointHistory]);

  const handlePageChange = (currentPage, limit) => {
    setPagination((prev) => ({ ...prev, currentPage, limit }));
  };

  return (
    <div>
      <Row justify="end" style={{ marginBottom: 16 }}>
        <Col>
          <Pagination
            total={pagination.totalSize}
            pageSize={pagination.limit}
            current={pagination.currentPage}
            onChange={handlePageChange}
          />
        </Col>
      </Row>

      <Table
        rowKey="objectId"
        columns={columns}
        dataSource={pointHistory}
        pagination={false}
        loading={loading}
        scroll={{ x: true }}
      />

      <Row justify="end" style={{ marginTop: 16 }}>
        <Col>
          <Pagination
            total={pagination.totalSize}
            pageSize={pagination.limit}
            current={pagination.currentPage}
            onChange={handlePageChange}
          />
        </Col>
      </Row>
    </div>
  );
};

export default UserPointHistory;
